module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C124"
  }, [_c('strong', [_c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_vm._v("ABBREVIATIONS")])])]), _c('a', {
    attrs: {
      "id": "page_xiii"
    }
  }, [_c('div', {
    staticClass: "table"
  }, [_c('table', {
    staticClass: "table1",
    attrs: {
      "cellpadding": "0px",
      "cellspacing": "0px"
    }
  }, [_c('tbody', [_c('tr', {
    staticClass: "Row_Style3"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("AB")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Assembly Bill (State of California)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style6"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("AFL")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("American Federation of Labor")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style6"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("ALRA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Agricultural Labor Relations Act (State of California)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style6"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("ALRB")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Agricultural Labor Relations Board (State of California)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style6"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("AWA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Agricultural Workers’ Association")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style6"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("AWOC")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Agricultural Workers Organizing Committee (under AFL-CIO)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style6"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("CAWIU")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Communists’ Cannery, and Agricultural Workers Industrial Union")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style6"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("CIO")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Congress of Industrial Organizations")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style6"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("CSO")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Community Service Organization")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style6"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("FWA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Farm Workers Association (precursor of the NFWA)")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style6"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("NFLU")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("National Farm Labor Union")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style5"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("NFWA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("National Farm Workers Association")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style2"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_c('a', {
    attrs: {
      "id": "page_xiv"
    }
  }, [_vm._v("NLRA")])]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("National Labor Relations Act")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style4"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("PL")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("Public Law")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style4"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("UCAPAWA")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("United Cannery, Agricultural, Packing, and Allied Workers of America")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style4"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("UFW")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("United Farm Workers")])]), _vm._v(" "), _c('tr', {
    staticClass: "Row_Style1"
  }, [_c('td', {
    staticClass: "Col_Style2"
  }, [_vm._v("UFWOC")]), _vm._v(" "), _c('td', {
    staticClass: "Col_Style1"
  }, [_vm._v("United Farm Workers Organizing Committee")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-546641eb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_ABBREVIATIONS.vue
// module id = 81
// module chunks = 0